import { nb } from 'date-fns/locale';

import { DateLocale } from './types/date-locale.type';
import { TimeZone } from './types/timezone.type';

declare global {
  interface Window {
    __timezoneDateUtilsLocaleId__?: DateLocale;
    __timezoneDateUtilsTimeZone__?: TimeZone;
  }
}

window.__timezoneDateUtilsLocaleId__ = nb;
window.__timezoneDateUtilsTimeZone__ = 'Europe/Oslo';

export * from 'date-fns/locale';

export const UTC_TIME_ZONE: TimeZone = 'UTC';
